import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatTreeModule } from '@angular/material/tree';

import { AbstractFormComponent } from './components/abstract-form.component';
import { AttachmentsListComponent } from './components/attachments-list/attachments-list.component';
import { AuditingNotesComponent } from './components/auditing-notes/auditing-notes.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DateOfServiceComponent } from './components/date-of-service/date-of-service.component';
import { EpisodeChipComponent } from './components/episode-chip/episode-chip.component';
import { EvidenceItemComponent } from './components/evidence-item/evidence-item.component';
import { ExpandableListComponent } from './components/expandable-list/expandable-list.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { FormLevelDetailsComponent } from './components/form-level-details/form-level-details.component';
import { LayoutContainerComponent } from './components/layout-container/layout-container.component';
import { NoteFormComponent } from './components/note-form/note-form.component';
import { NotesDialogComponent } from './components/notes-dialog/notes-dialog.component';
import { PdfHistoryListComponent } from './components/pdf-history-list/pdf-history-list.component';
import { PlanGroupComponent } from './components/plan-group/plan-group.component';
import { ProviderFilterComponent } from './components/provider-filter/provider-filter.component';
import { QualitySubmissionsDialogComponent } from './components/quality-submissions-dialog/quality-submissions-dialog.component';
import { QueryInputPeriodSelectorComponent } from './components/query-input-period-selector/query-input-period-selector.component';
import { ReasonCodeChipComponent } from './components/reason-code-chip/reason-code-chip.component';
import { StringFilterComponent } from './components/string-filter/string-filter.component';
import { DisableAutoCompleteDirective } from './directives/disable-auto-complete.directive';
import { FunctionDisplayModule } from './function-display';
import { LookupSearchModule } from './lookup-search';
import { EmptyPipe } from './pipes/empty.pipe';
import { FormatBytesPipe } from './pipes/format-bytes.pipe';
import { FormatDateUtcPipe } from './pipes/format-date-utc.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { FormatErrorPipe } from './pipes/format-error.pipe';
import { HtmlPipe } from './pipes/html.pipe';
import { RemoveTimeZonePipe } from './pipes/remove-time-zone.pipe';
import { SplitPipe } from './pipes/split.pipe';
import { UuidPipe } from './pipes/uuid.pipe';

const components = [
  AttachmentsListComponent,
  ConfirmationDialogComponent,
  EpisodeChipComponent,
  EvidenceItemComponent,
  ExpandableListComponent,
  FileUploadComponent,
  LayoutContainerComponent,
  NoteFormComponent,
  NotesDialogComponent,
  ProviderFilterComponent,
  PdfHistoryListComponent,
  QueryInputPeriodSelectorComponent,
  ReasonCodeChipComponent,
  AuditingNotesComponent,
  PlanGroupComponent,
  DateOfServiceComponent,
  AbstractFormComponent,
  FormLevelDetailsComponent,
  StringFilterComponent,
  QualitySubmissionsDialogComponent,
];
const directives = [DisableAutoCompleteDirective];
const pipes = [
  EmptyPipe,
  FormatBytesPipe,
  FormatDatePipe,
  FormatDateUtcPipe,
  FormatErrorPipe,
  HtmlPipe,
  RemoveTimeZonePipe,
  SplitPipe,
  UuidPipe,
];
const modules = [FunctionDisplayModule, LookupSearchModule];

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    LookupSearchModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    MatTreeModule,
    ReactiveFormsModule,
    ScrollingModule,
  ],
  declarations: [...components, ...directives, ...pipes],
  exports: [...components, ...directives, ...pipes, ...modules],
})
export class BrowserCommonUiModule {}
